export default __webpack_public_path__ + "static/media/Loading_Dye_LD.86fdcc2c.svg";